<template>
    <div style="width: 100%;display: flex;justify-content: space-between;align-items:center;">
        <div v-if="!statusBloqueado" class="icone-selecionado" >
            <img src='../../assets/icons/status/icon-aguardando.png' alt="">
            <h4 class="texto-icon-status">Aguardando</h4>
        </div>
        <hr :class="returnClassHR('primeiro')" v-if="!statusBloqueado">
        <div v-if="!statusBloqueado" class="icone-selecionado" :class="status!=='AGUARDANDO'?'icone-selecionado':'icone-nao-selecionado'">
            <img src='../../assets/icons/status/icon-produzindo.png' alt="">
            <h4 class="texto-icon-status">Produzindo</h4>
        </div>
        <hr :class="returnClassHR('segundo')" v-if="!statusBloqueado">
        <div v-if="!retirar&&!statusBloqueado" :class="status==='ENTREGA'||status==='CONCLUIDO'?'icone-selecionado':'icone-nao-selecionado'" >
            <img src='../../assets/icons/status/icon-entrega.png' alt="">
            <h4 class="texto-icon-status">Entrega</h4>
        </div>
        <div v-if="retirar&&!statusBloqueado" :class="status==='PRONTO RETIRADA'||status==='CONCLUIDO'?'icone-selecionado':'icone-nao-selecionado'" >
            <img src='../../assets/icons/status/icon-retirar.png' alt="">
            <h4 class="texto-icon-status">Retirar</h4>
        </div>
        <hr :class="returnClassHR('terceiro')" v-if="!statusBloqueado">
        <div v-if="!statusBloqueado" :class="status==='CONCLUIDO'?'icone-selecionado':'icone-nao-selecionado'" >
            <img src='../../assets/icons/ic-checked.svg' alt="">
            <h4 class="texto-icon-status">Concluido</h4>
        </div>
        <div v-if="status==='CANCELADO'" class="icone-selecionado">
            <img src='../../assets/icons/status/icon-cancelado.png' alt="">
            <h4 class="texto-icon-status">Cancelado</h4>
        </div>
        <div v-if="status==='PAGAMENTO PENDENTE'" class="icone-selecionado">
            <img src='../../assets/icons/status/icon-carteira.png' alt="">
            <h4 class="texto-icon-status">Pagamento pendente</h4>
        </div>
        <div v-if="status==='PAGAMENTO NÃO EFETUADO'" class="icone-selecionado" >
            <img src='../../assets/icons/status/icon-carteira.png' alt="">
            <h4 class="texto-icon-status">Pagamento não efetuado</h4>
        </div>
        <!-- <p>{{status}}</p> -->
    </div>
</template>
<script>
    export default {
        name:'ShowStatusPedido',
        props:{
            status:String,
            retirar:Boolean,
        },
        computed:{
            statusBloqueado(){
                if(this.status==='PAGAMENTO PENDENTE'||this.status==='PAGAMENTO NÃO EFETUADO'||this.status==='CANCELADO')
                    return (true)
                else
                    return(false)
            },
        },
        methods: {
            returnClassHR(position){
                if(position==='primeiro'){
                    if(this.status==='AGUARDANDO'){
                        return ('line-medium-select')
                    }
                    else{
                        return ('line-select')
                    }
                }
                else {
                    if(position==='segundo'){
                        if(this.status==='AGUARDANDO')
                            return ('line-un-select')
                        else
                            if(this.status==='PRODUZINDO')
                                return ('line-medium-select')
                            else
                                return ('line-select')
                    }
                    else{
                        if(position==='terceiro'){
                            if(this.status==='ENTREGA'||this.status==='PRONTO RETIRADA'){
                                return ('line-medium-select')
                            }
                            else {
                                if(this.status==='PRODUZINDO'||this.status==='AGUARDANDO'){
                                    return ('line-un-select')
                                }else {
                                    return ('line-select')
                                }
                            }
                        }
                        else   return ('')
                    }
                }
            }
        },
        
    }
</script>
<style scoped>
.icone-selecionado,.icone-nao-selecionado{
    border-radius: 5px;
    padding: 5px;
}
.icone-selecionado>img,.icone-nao-selecionado>img{
    width: 20px;
}
.icone-selecionado{
    background: var(--cor2);
}
.icone-nao-selecionado{
    background: var(--cinza-escuro);
    opacity: 0.5;
}
/*Linhas*/
.line-select,.line-un-select,.line-medium-select{
    width: 100%;
    height: 4px;
    border: none;
}
.line-select{
    background: var(--cor2);
}
.line-medium-select{
    background: linear-gradient(to right,var(--cor2) 50%,var(--cinza-escuro) 50%);
}
.line-un-select{
    background: var(--cinza-escuro);
}
.texto-icon-status{
    font-size: 0.4rem;
    margin: 0px;
    color: white;
    min-width: 35px;
}
</style>